import { axios, API } from "@/imports-files/common/common";
import { SendRequest } from "@/imports-files/pages/admins/logout";

export class SidebarService extends SendRequest
{
  async getProfilePhotoUrl()
  {
      const url =  API.user_sidebar_data
      try
      {
          const result = await axios.get(url,
          {
              headers: this.customHeaderJSON()
          },
          this.setHeaderJSON(),
          this.setCrossDomainTrue(),
          this.setCredentialsJSON());
          return result;
      }
      catch (error)
      {
        return error;
      }
  }
}